import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'frontend-time-input-ampm',
  templateUrl: './time-input-ampm.component.html',
  styleUrls: ['./time-input-ampm.component.scss'],
  standalone: false
})
export class TimeInputAmPmComponent {
  @Input() form: FormGroup;
}
